import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['trigger', 'form']

  expand() {
    this.triggerTarget.classList.add('hidden')
    this.formTarget.classList.remove('hidden')
    const textarea = this.formTarget.querySelector('textarea')
    if (!textarea) return
    textarea.focus()
    this.resize(textarea)
  }

  collapse() {
    this.formTarget.classList.add('hidden')
    this.triggerTarget.classList.remove('hidden')
  }

  autogrow(event) {
    this.resize(event.target)
  }

  keydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault()
      this.collapse()
      return
    }

    if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault()
      event.target.form?.requestSubmit()
    }
  }

  resize(textarea) {
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight}px`
  }
}
